<template>
	<div style="width: 100%" class="menuBody">
		<el-container style="background: #fff; width: 100%">
			<el-aside style="width: 240px; padding-left: 20px; padding-top: 20px">
				<left-floor-tree @chooseNode="selectNode"></left-floor-tree>
			</el-aside>
			<el-main style="padding-left: 0px; padding-top: 20px">
				<el-tabs shadow="never" v-model="currentTab" type="border-card">
					<el-tab-pane name="paid" label="已支付列表"
						><paid-table :parentData="currentTreeNodeData" v-if="currentTab == 'paid'"></paid-table
					></el-tab-pane>
					<el-tab-pane v-if="show('hydropower.web.charge.order.exportPayableList')" name="shouldPay" label="应支付列表"
						><should-pay-table :parentData="currentTreeNodeData" v-if="currentTab == 'shouldPay'"></should-pay-table
					></el-tab-pane>
					<!-- <el-tab-pane name="adjustCharge" label="调整收费列表"><adjust-charge-table v-if="currentTab == 'adjustCharge'" ></adjust-charge-table></el-tab-pane> -->
				</el-tabs>
			</el-main>
		</el-container>
	</div>
</template>
<script>
import AdjustChargeTable from "./components/AdjustChargeTable.vue";
import PaidTable from "./components/PaidTable.vue";
import ShouldPayTable from "./components/ShouldPayTable.vue";
import LeftFloorTree from "@/components/LeftFloorTree.vue";
import {Juris} from "@/directives/Juris";
export default {
	name: "MeterOrderIndex",
	components: { PaidTable, ShouldPayTable, AdjustChargeTable, LeftFloorTree },
	data() {
		return {
			currentTab: "paid",
			currentTreeNodeData: {},
		};
	},
	methods: {
		selectNode(data) {
			this.currentTreeNodeData = data;
		},
        show(permitFlag) {
            return Juris(permitFlag);
        }
	},
	mounted() {},
};
</script>
<style scoped>
.menuBody >>> .el-tabs__nav-scroll {
    background: #fff;
    border-top: 0px solid #E4E7ED;
}
</style>